export enum AgreementStatus {
    NONE,
    DECLINED,
    ACCEPTED,
}
